module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJAQMAAADElqTgAAAABlBMVEUAAAD/Pj0CUtpOAAAAAXRSTlMAQObYZgAAABxJREFUeF49xEENAAAAAUARxBFOduNltx10gTcLGGAC2+VqnDoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/down.png
// module id = yGdi
// module chunks = 1